<template>
    <BaseModal>
        <div class="confirm_deletion" @click.stop>
            <h3>{{ $t('comments.delete.title') }}</h3>
            <p>{{ $t('comments.delete.description') }}</p>
            <div class="confirm_box">
                <button class="confirm_btn" @click="confirmDeletion">{{ $t('comments.delete.confirm') }}</button>
                <button class="confirm_close" @click="close">{{ $t('comments.delete.close') }}</button>
            </div>
        </div>
    </BaseModal>
</template>

<script>
import BaseModal from "@/UI/Modals/BaseModal.vue";
import { useModalStore } from "@/stores/modalStore";
import { deleteComment } from "@/api/axios.js";

export default {
    name: "ConfirmDeletion",
    components: { BaseModal },
    props: {
        commentId: {
            type: Number,
            required: true
        },
        onDeleted: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            modal: useModalStore(),
        }
    },
    methods: {
        async confirmDeletion() {
            try {
                await deleteComment(this.commentId);
                this.onDeleted?.(this.commentId);
                this.close();
            } catch (e) {
                console.log("Delete error", e);
            }
        },
        close() {
            const modalItem = this.modal.modals.slice(-1);
            this.modal.closeModal(modalItem.id);
        }
    }
}
</script>

<style>
.confirm_deletion {
    padding: 30px 20px;
    text-align: center;
    background: var(--bg-color);
    border-radius: 33px;
    min-height: 100px;
    min-width: 200px;
    max-width: 230px;
    max-height: 240px;
    margin: auto 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.confirm_deletion p {
    font-size: 14px;
}

.confirm_box {
    display: flex;
    justify-content: center;
    gap: 15px;
}

.confirm_btn {
    background: var(--main-color);
    color: black;
    font-weight: 600;
    border-radius: 12px;
    width: 100px;
    height: 36px;
    cursor: pointer;
}

.confirm_btn:hover {
    background: var(--main-color-hover);
}

.confirm_close {
    background: var(--edit-profile-form);
    color: var(--text-color);
    font-weight: 600;
    border-radius: 12px;
    width: 100px;
    height: 36px;
    cursor: pointer;
}

.confirm_close:hover {
    background: var(--hover);
}
</style>
